/* eslint-disable no-prototype-builtins */
import _ from 'lodash';
import isEmail from 'sane-email-validation';
import { KATAKANA_REGEX } from 'utilities/constants';
import { isEmpty } from 'utilities/handleValues';
import { VALIDATE_MESSAGE } from 'utilities/messages';
// import { PHONE_REGEX } from 'utilities/constants';

// function telephoneCheck(str) {
//   return !!PHONE_REGEX.test(str);
// }

const validate = values => {
  const errors = {};
  // avatarId
  const avatarId = values.get('avatarId');
  if (!avatarId) {
    errors.avatarId = VALIDATE_MESSAGE.REQUIRED;
  }
  // Validate firstName
  const firstName = values.get('firstName');
  if (isEmpty(firstName)) {
    errors.firstName = VALIDATE_MESSAGE.REQUIRED; // "This value is required."
  } else if (firstName.length > 10) {
    errors.firstName = VALIDATE_MESSAGE.MAX_CHARS(10);
  }

  // Validate lastName
  const lastName = values.get('lastName');
  if (isEmpty(lastName)) {
    errors.lastName = VALIDATE_MESSAGE.REQUIRED; // "This value is required."
  } else if (lastName.length > 10) {
    errors.lastName = VALIDATE_MESSAGE.MAX_CHARS(10);
  }

  // Validate lastNameHiragana
  const lastNameHiragana = values.get('lastNameHiragana');
  if (isEmpty(lastNameHiragana)) {
    errors.lastNameHiragana = VALIDATE_MESSAGE.REQUIRED; // "This value is required."
  } else if (lastNameHiragana.length > 10) {
    errors.lastNameHiragana = VALIDATE_MESSAGE.MAX_CHARS(10);
  } else if (!KATAKANA_REGEX.test(lastNameHiragana)) {
    errors.lastNameHiragana = VALIDATE_MESSAGE.INVALID_KATAKANA;
  }

  // Validate firstNameHiragana
  const firstNameHiragana = values.get('firstNameHiragana');
  if (isEmpty(firstNameHiragana)) {
    errors.firstNameHiragana = VALIDATE_MESSAGE.REQUIRED; // "This value is required."
  } else if (firstNameHiragana.length > 10) {
    errors.firstNameHiragana = VALIDATE_MESSAGE.MAX_CHARS(10);
  } else if (!KATAKANA_REGEX.test(firstNameHiragana)) {
    errors.firstNameHiragana = VALIDATE_MESSAGE.INVALID_KATAKANA;
  }

  // const phone = values.get('phone');
  // if (!phone) {
  //   errors.phone = 'この値は必須です。';
  // } else if (!telephoneCheck(phone)) {
  //   errors.phone = 'Invalid Phone Number';
  // }

  const email = values.get('email');
  if (!email) {
    errors.email = 'この値は必須です。';
  } else if (!isEmail(email)) {
    errors.email = 'Invalid email';
  }

  const introduction =
    values.get('studentProfile') &&
    values.get('studentProfile').get('introduction');
  if (!introduction || _.isEmpty(_.trim(introduction))) {
    if (!errors.hasOwnProperty('studentProfile')) {
      errors.studentProfile = {};
    }
    errors.studentProfile.introduction = 'この値は必須です。';
  }

  const club =
    values.get('studentProfile') && values.get('studentProfile').get('club');
  if (!club || _.isEmpty(_.trim(club))) {
    if (!errors.hasOwnProperty('studentProfile')) {
      errors.studentProfile = {};
    }
    errors.studentProfile.club = 'この値は必須です。';
  }

  const companyTags =
    values.get('studentProfile') &&
    values.get('studentProfile').get('companyTags');
  if (!companyTags || _.isEmpty(companyTags)) {
    if (!errors.hasOwnProperty('studentProfile')) {
      errors.studentProfile = {};
    }
    errors.studentProfile.companyTags = 'この値は必須です。';
  }

  return errors;
};

export default validate;